import React, { useCallback, useEffect, useState } from "react";
import { getAllParticipantsOfAssessment, getAsmtById, getQuestionFromConfig, getUserByUserId } from "../../services/authService";
import { useParams } from "react-router-dom";
import { decodeId } from "../../utills/idUtils";

const QualitativeFeedback = () => {
    const { encodedId } = useParams();
    const id = decodeId(encodedId)
    const [participantsData, setParticipantsData] = useState([]);
    const [assessmentType, setAssessmentType] = useState("");

    console.log(participantsData, "partparticipantsDataicipantsData")


    const fetchAllParticipants = useCallback(async () => {
        try {
            const allParticipants = await getAllParticipantsOfAssessment(id);
            setParticipantsData(allParticipants.data);
        } catch (err) {
            console.error("Error fetching participants:", err);
        }
    }, [id]); // Add 'id' as a dependency here

    useEffect(() => {
        const fetchData = async () => {
            try {
                const asmtData = await getAsmtById(id);
                setAssessmentType(asmtData.assessment_type); // Set assessment type

                await fetchAllParticipants(); // Call fetchAllParticipants
            } catch (error) {
                console.error("Error fetching assessment data:", error);
            }
        };

        fetchData();
    }, [fetchAllParticipants, id]);



    return (
        <div className=" rounde p-4  lg:px-16" >

            <div style={{ pageBreakAfter: 'always' , breakAfter: "page" }}></div>
            <div className="rounded-2xl" style={{ background: "rgb(230 230 230  / var(--tw-bg-opacity, 1))" }}>
                <div className=" pt-4  ">
                    {/* <div className="bg-blue-700 text-white text-lg font-bold p-2 mb-2"> */}
                    <h3 className="bg-blue-700 text-white text-lg font-bold p-2" style={{ paddingBottom: "5px", fontFamily: 'Helvetica' }}>
                        SECTION 3 : Qualitative Feedback</h3>
                    {/* </div> */}

                    <div className="p-4 text-black mt-2">
                        <h4 className="font-semibold bg-blue-200 p-2" style={{ paddingBottom: "px", fontFamily: 'Helvetica' }}>
                            {assessmentType === "360"
                                ? "a) What do respondents see as your strengths?"
                                : "a) What do you see as your Strengths? Could you share some examples of situations where you have used these strengths effectively?"}

                        </  h4>
                    </div>
                </div>

                <div className="p-4  gap-4 grid-cols-1 sm:grid-cols-2 " >
                    {participantsData.length > 0 && participantsData.some(participant => participant.strength) ? (
                        participantsData.map((participant, index) => (
                            participant.strength ? (
                                <div style={{ fontSize: "15px", paddingBottom: "5px", fontFamily: 'Helvetica', background: 'rgb(207 225 254 / var(--tw-bg-opacity, 1))' }}
                                    key={index}
                                    className=" p-3 mb-2 rounded-lg text-gray-700 "
                                >
                                    <p> {participant.strength}</p>
                                </div>
                            ) : null
                        ))
                    ) : (
                        <p>No feedback available.</p>
                    )}

                </div>

                <div className=" ">
                    <div className=" text-black p-4">
                        <h4 className="font-semibold bg-blue-200 p-2" style={{ paddingBottom: "6px", fontFamily: 'Helvetica' }}>
                            {assessmentType === "360"
                                ? "b) What do respondents see as your development opportunities? What areas should you focus on improving, and why?"
                                : "b) What do you see as your Development Opportunities? I.e. What should you do differently and why?"}


                        </h4>
                    </div>
                </div>

                <div className="p-4  gap-4 grid-cols-1 sm:grid-cols-2 ">
                    {participantsData.length > 0 && participantsData.some(participant => participant.area_of_improvement) ? (
                        participantsData.map((participant, index) => (
                            participant.area_of_improvement ? (
                                <div
                                    key={index}
                                    className=" p-3 mb-2 rounded-lg   text-gray-700" style={{ paddingBottom: "6px", fontFamily: 'Helvetica', background: 'rgb(207 225 254 / var(--tw-bg-opacity, 1))' }}
                                >
                                    <p><strong></strong> {participant.area_of_improvement}</p>
                                </div>
                            ) : null
                        ))
                    ) : (
                        <p>No feedback available.</p>
                    )}

                </div>

                {/* Section c) */}
                <div className=" ">
                    <div className=" text-black p-4">
                        <h4 className="font-semibold bg-blue-200 p-2" style={{ paddingBottom: "5px", fontFamily: 'Helvetica' }}>
                            {assessmentType === "360"
                                ? "c) Have respondents noticed any key Improvements in you over the last year? What are they?"
                                : "c) Have you noticed any key Improvements in yourself over the last year? What are they?"}







                        </h4>
                    </div>
                </div>

                {/* <div className="p-4  gap-4 grid-cols-1 sm:grid-cols-2 rounded-br-md rounded-bl-md ">
                    {participantsData.length > 0 &&

                        participantsData.some(participant => participant.key_improvement

                        ) ? (
                        participantsData.map((participant, index) => (
                            participant.key_improvement ? (
                                <div
                                    key={index}
                                    className=" p-3 mb-2 rounded-lg   text-gray-700" style={{ paddingBottom: "5px", fontFamily: 'Helvetica', background: 'rgb(207 225 254 / var(--tw-bg-opacity, 1))' }}
                                >
                                    <p><strong></strong> {participant.key_improvement}</p>
                                </div>
                            ) : null
                        ))
                    ) : (
                        <p>No feedback available.</p>
                    )}

                </div> */}

                <div className="p-4 gap-4 grid-cols-1 sm:grid-cols-2 rounded-br-md rounded-bl-md">
                    {participantsData.length > 0 &&
                        participantsData.some(
                            (participant) =>
                                participant.strength &&
                                participant.key_improvement 
                        ) ? (
                        participantsData.map((participant, index) =>
                            participant.strength &&
                                participant.key_improvement  ? (
                                <div
                                    key={index}
                                    className="p-3 mb-2 rounded-lg text-gray-700"
                                    style={{
                                        paddingBottom: "5px",
                                        fontFamily: "Helvetica",
                                        background: "rgb(207 225 254 / var(--tw-bg-opacity, 1))",
                                    }}
                                >
                                    <p>{participant.key_improvement}</p>
                                </div>
                            ) : null
                        )
                    ) : (
                        <p>No feedback available.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default QualitativeFeedback;
